// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/admin.css
// module id = 1
// module chunks = 1